/**
 * ヘッダ
 *
 * @param {HTMLElement} header
 * @param {HTMLElement} gnav
 * @returns {void}
 */
export default function appHeader(header, gnav) {
  if (!header || !gnav) return;

  const invertClassName = 'l-header--invert';
  const setInvert = () => header.classList.add(invertClassName);
  const resetInvert = () => header.classList.remove(invertClassName);

  gnav.addEventListener(
    'show',
    (e) => {
      if (!e.detail.mq.matches) setInvert();
    },
    false
  );

  gnav.addEventListener('hide', () => resetInvert(), false);

  gnav.addEventListener(
    'show:submenu',
    (e) => {
      if (e.detail.mq.matches) setInvert();
    },
    false
  );

  gnav.addEventListener(
    'hide:submenu',
    (e) => {
      if (e.detail.mq.matches) resetInvert();
    },
    false
  );
}
